export default class QueryParameterBuilder {
    params;
    constructor() {
        this.params = {};
    }
    addHubIds(queryParameter) {
        if (!queryParameter) {
            return this;
        }
        this.add('hubIds', queryParameter);
        return this;
    }
    addFields(queryParameter) {
        const { fields, } = this.params;
        this.params.fields = fields ? `${fields},${queryParameter}` : queryParameter;
        return this;
    }
    addEmbeds(queryParameter) {
        const { embeds, } = this.params;
        this.params.embeds = embeds ? `${embeds},${queryParameter}` : queryParameter;
        return this;
    }
    addFilters(queryParameter) {
        if (!queryParameter) {
            return this;
        }
        const { filters, } = this.params;
        this.params.filters = filters ? `${filters},${queryParameter}` : queryParameter;
        return this;
    }
    addSortBy(queryParameter) {
        if (!queryParameter) {
            return this;
        }
        const { sortBy, } = this.params;
        this.params.sortBy = sortBy ? `${sortBy},${queryParameter}` : queryParameter;
        return this;
    }
    addPageNumber(pageNumber) {
        this.add('pageNumber', `${pageNumber}`);
        return this;
    }
    addPage(pageNumber) {
        this.add('page', `${pageNumber}`);
        return this;
    }
    addPageSize(pageSize) {
        this.add('pageSize', `${pageSize}`);
        return this;
    }
    addSize(pageSize) {
        this.add('size', `${pageSize}`);
        return this;
    }
    addFromAt(fromAt) {
        this.add('fromAt', `${fromAt}`);
        return this;
    }
    addToAt(toAt) {
        this.add('toAt', `${toAt}`);
        return this;
    }
    addStoreName(storeName) {
        if (!storeName) {
            return this;
        }
        this.add('storeName', `${storeName}`);
        return this;
    }
    add(key, value) {
        this.params[key] = `${value}`;
        return this;
    }
    /**
     * 검색 관련
     */
    addSearchWord({ field, value }) {
        if (!value) {
            return this;
        }
        this.params[field] = value;
        return this;
    }
    build() {
        return new URLSearchParams(this.params);
    }
}
